<template>
  <div>
    <GenreView
      :publications="publications"
      :searcher="searcher"
      :sort-strategy="sortStrategy"
      :custom-counter="customCounter"
      :genre="genre"
    />
    <AppFooter />
  </div>
</template>

<script>
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('index.vue');
import pageCommonMixin from '@/components/mixins/pageCommonMixin';
import publicationUtils from '@/services/utils/publicationUtils';

import CustomCategoriesEnum from '@shared/enums/CustomCategoriesEnum';
import ManagePublicationsStates from '@/enums/ManagePublicationsStatesEnum';
import SearchPublicationsFactory from '@/classes/factories/SearchPublicationsFactory';

import GenreView from '@/components/views/CategoryView/GenreView.vue';
import AppFooter from '@/components/views/AppFooter/AppFooter.vue';

function getSearcher(store, genre) {
  const currentLanguage = store.getters['ContextStore/currentLanguageGetter'];
  const genreSearcher = store.getters['LibraryStore/getGenreSearcher'];

  const newSearcher = SearchPublicationsFactory.searcherToBuilder(genreSearcher)
    .setState(ManagePublicationsStates.LIBRARY)
    .setLanguage(currentLanguage)
    .setGenres([genre])
    .setCollectionIncluded(true)
    .setExcludedCategories([
      CustomCategoriesEnum.NEW,
      CustomCategoriesEnum.RECENT,
      CustomCategoriesEnum.SUGGESTED_BOOK
    ])
    .build();
  return newSearcher;
}

async function libraryState(store) {
  if (process.server) {
    store.dispatch('LibraryStore/destroyStates', [
      ManagePublicationsStates.LIBRARY
    ]);
  }
  await store.dispatch('LibraryStore/initState', {
    managePublicationsState: ManagePublicationsStates.LIBRARY
  });
}

export default {
  name: 'GenrePage',
  components: {
    GenreView,
    AppFooter
  },
  mixins: [pageCommonMixin],
  async asyncData({ store, params }) {
    try {
      await libraryState(store);
      const searcher = getSearcher(store, params.genreSlug);
      let publications = store.getters['LibraryStore/searchPublications'](
        searcher
      );
      let customCounter;
      const sortStrategy = store.getters['ContextStore/librarySortStrategy'];
      if (process.server && publications?.length) {
        customCounter = publicationUtils.countPublicationItems(publications);
        publications = publicationUtils.sortPublication(
          publications,
          sortStrategy
        );
        publications = publications.slice(0, 15);
        store.commit('LibraryStore/destroyLibrary');
      }
      const { meta, title } = await store.dispatch(
        'ContextStore/getGenrePageHeadInfo',
        params.genreSlug
      );
      let genre = await store.dispatch('LibraryStore/getGenreBySlug', {
        slug: params.genreSlug
      });
      if (genre?._id) {
        genre.imageUrl = await store.dispatch(
          'LibraryStore/getGenreImageUrl',
          genre?.image
        );
      } else {
        genre = { name: publications?.[0]?.genre || params.genre || '' };
      }

      return {
        publications,
        searcher,
        sortStrategy,
        genre,
        customCounter,
        meta,
        title
      };
    } catch (error) {
      logger.fatal(`Get error on create category page error: ${error}`);
    }
    return {};
  },
  data() {
    return {
      searcher: this.searcher,
      publications: this.publications,
      sortStrategy: this.sortStrategy,
      genre: this.genre,
      customCounter: this.customCounter
    };
  },
  head() {
    const headSettings = this.getCommonHeadSettings();

    return {
      ...headSettings,
      link: this.link,
      title: this.title,
      meta: this.meta
    };
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if (mutation.type === 'ContextStore/setServiceClientInit') {
        this.publications = null;
        this.customCounter = null;
      }
    });
  }
};
</script>

<style></style>
